if (!customElements.get('quick-add-to-basket')) {
  customElements.define(
    'quick-add-to-basket',
    class QuickAddToBasket extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.button?.addEventListener('click', () => this.add());
      }

      async add() {
        const cart = document.querySelector('cart-drawer');
        this.button.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch(`${window.routes.cart_add_url}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: Number(this.button.dataset.variantId), quantity: 1 }],
              sections: cart && typeof cart.getSectionsToRender === 'function' ? cart.getSectionsToRender().map((s) => s.id) : [],
              sections_url: window.location.pathname,
            }),
          });
          const state = await response.json();
          if (!response.ok || state.status) throw new Error(state.description || state.message || 'Could not add');
          if (cart && typeof cart.renderContents === 'function') {
            // The drawer must leave its empty layout before it opens
            cart.classList.remove('is-empty');
            cart.renderContents(state);
          } else {
            window.location = window.routes.cart_url;
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-add-to-basket', cartData: state });
          }
        } catch (e) {
          this.button.textContent = 'Sorry, try again';
        } finally {
          this.button.removeAttribute('aria-busy');
        }
      }
    }
  );
}
